import React from "react";
//#region types
import { FileViewerHtmlState, FileViewerInnerProps } from "models/propTypes/fileViewerPropTypes";
//#endregion
//#region components
import { FileViewerContext } from "components/common/fileViewer/context";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { UtilsHelper } from "utils/helpers";

class FileViewerHtml extends React.Component<FileViewerInnerProps, FileViewerHtmlState> {
  static contextType = FileViewerContext;
  context!: React.ContextType<typeof FileViewerContext>;

  mounted: boolean = true;
  iFrameRef: HTMLIFrameElement | undefined = undefined;
  readonly maxScale = 0.99;
  readonly iFrameWidth = 794;
  readonly iFrameHeight = 1122;

  constructor(props: FileViewerInnerProps) {
    super(props);

    this.state = {
      scale: 0,
      translateX: 0,
      width: this.iFrameWidth,
      height: this.iFrameHeight,
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
    this.iFrameRef = undefined;
  }

  componentDidUpdate(prevProps: FileViewerInnerProps) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.currentFile.data !== prevProps.currentFile.data ||
      this.props.containerWidth !== prevProps.containerWidth ||
      this.props.containerHeight !== prevProps.containerHeight
    ) {
      this.setImageWidthHeight();
    }
  }

  onLoad() {
    this.setImageWidthHeight();
    this.updatePageCount();
    this.navigateToPage();
  }

  setImageWidthHeight = () => {
    const { containerWidth, containerHeight } = this.props;

    const scaleHorizontal = this.iFrameWidth ? containerWidth / this.iFrameWidth : 0;
    const scaleVertical = this.iFrameHeight ? containerHeight / this.iFrameHeight : 0;
    const scale = scaleHorizontal < scaleVertical ? scaleHorizontal : scaleVertical;

    if (!this.props.fullScreen && this.context?.setUploadedFileDimensions) {
      this.context.setUploadedFileDimensions({ width: undefined, height: undefined });
    }

    this.mounted &&
      this.setState({
        scale: scale,
        translateX: this.iFrameWidth
          ? scale > 1
            ? (containerWidth - this.iFrameWidth) / 2
            : (containerWidth - scale * this.iFrameWidth) / 2
          : 0,
        width: this.iFrameWidth * scale,
        height: this.iFrameHeight * scale,
        contentWidth: scale > this.maxScale ? containerWidth : undefined,
        contentHeight: scale > this.maxScale ? containerHeight : undefined,
      });
  };

  navigateToPage = () => {
    if (this.iFrameRef) {
      const frameHeight = this.iFrameRef.clientHeight;
      const position = (this.props.currentPage - 1) * frameHeight;
      const iframeDoc = this.iFrameRef.contentDocument || this.iFrameRef.contentWindow?.document;
      iframeDoc?.scrollingElement?.scrollTo(0, position);
    }
  };

  updatePageCount = () => {
    if (this.iFrameRef) {
      const iframeDoc = this.iFrameRef.contentDocument || this.iFrameRef.contentWindow?.document;
      const pageCount = UtilsHelper.getMultiHtmlPageCount(iframeDoc);

      if (pageCount > 1) {
        this.props.updateMetaInfo &&
          this.props.updateMetaInfo(
            this.props.currentPage - 1,
            this.props.currentFile.imageId,
            [...Array(pageCount)].map((index) => ({
              ...this.props.currentFile,
              pageNumber: index,
            }))
          );
      }
    }
  };

  render() {
    return !this.props.isLoading && this.props.currentFile.data ? (
      <div
        className={cssExports.htmlFileContainer}
        style={{
          transform: `scale(${this.state.scale})`,
          width: this.props.fullScreen ? undefined : this.state.width,
          height: this.props.fullScreen ? undefined : this.state.height,
          visibility: this.state.scale === 0 ? "hidden" : "visible",
        }}
      >
        <iframe
          title="htmlView"
          ref={(container: any) => (this.iFrameRef = container)}
          onLoad={this.onLoad.bind(this)}
          srcDoc={this.props.currentFile.data}
          sandbox="allow-same-origin allow-scripts"
          scrolling="no"
        ></iframe>
      </div>
    ) : (
      <></>
    );
  }
}

export default FileViewerHtml;
